'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $d_Lapp_pages_AppPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "app.pages.AppPage", ({
  Lapp_pages_AppPage: 1
}));
export { $d_Lapp_pages_AppPage as $d_Lapp_pages_AppPage };
//# sourceMappingURL=app.pages.-App-Page.js.map
